import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import { useTranslation } from '~/_shared/utils/hooks';
import { openMapTool } from '~/store/frontendState/leftSidebar/leftSidebar.actionCreators';
import { removeRouteFromDirections } from '~/store/mapSettings/directions/mapSettingsDirections.actionCreators';
import { useMapSettingsDirectionsRoutesSelector } from '~/store/mapSettings/directions/mapSettingsDirections.selectors';
import {
  toolStateHideRoute, toolStateShowRoute,
} from '~/store/mapSettings/toolsState/visibility/visibility.actionCreators';
import { useHiddenRouteIdsSelector } from '~/store/mapSettings/toolsState/visibility/visibility.selectors';
import { useMapIdSelector } from '~/store/selectors/useMapIdSelector';
import { createMapStatusBarItemFromRoute } from '../item/mapStatusBarItem.factory';
import { type MapStatusBarItem } from '../mapStatusBarItem.type';

export const useDirectionsStatusBarItems = () => {
  const routes = useMapSettingsDirectionsRoutesSelector();
  const hiddenRoutes = useHiddenRouteIdsSelector();
  const mapId = useMapIdSelector();
  const dispatch = useDispatch();
  const [t] = useTranslation();

  return useMemo<MapStatusBarItem[]>(() => {
    if (mapId) {
      return routes.map(route => {
        return createMapStatusBarItemFromRoute({
          isVisible: !hiddenRoutes.includes(route.id),
          routeName: route.name, t,
          onRemove: () => dispatch(removeRouteFromDirections(route, mapId)),
          onClick: () => dispatch(openMapTool(MapTool.Routing)),
          onVisibilityChange: (isVisible: boolean) => {
            if (isVisible) {
              dispatch(toolStateShowRoute(route.id));
            }
            else {
              dispatch(toolStateHideRoute(route.id));
            }
          },
        });
      });
    }

    return [];
  }, [mapId, routes, t, dispatch, hiddenRoutes]);
};
